// extracted by mini-css-extract-plugin
export default {"wrapperNotFound":"NoteFound_wrapperNotFound__8xo51","titleNotFound":"NoteFound_titleNotFound__Gjt3P","textNotFound":"NoteFound_textNotFound__vwsiq"};